<template>
<PageHeader :title="resolvedPlaceTitle" />
<CitySubnav :cities="['amsterdam','hamburg','berlin','paris','Utrecht','Norway', 'Costa Rica','San Diego','Panama','Seattle','Seoul','Dublin', 'San Juan']" />
    <div class="portfolio">
    <h1 class="page-title">{{ resolvedPlaceTitle }}</h1>
    
  <PortfolioJustified
    :items="items"
    :target-row-height="500"
    :gutter="12"
    last-row="left"
    :show-captions="true"
    />

  </div>
</template>

<script setup>

import { ref, computed, onMounted } from 'vue'

import { useRoute } from 'vue-router'
import PageHeader from './PageHeader.vue'
import PortfolioJustified from '@/components/PortfolioJustified.vue'
import CitySubnav from '@/components/CitySubnav.vue'

const props = defineProps({
  place: { type: String, required: false } // can be passed from router or parent
})

// read from prop *or* route param (if you configured props: true on the route)
const route = useRoute()
const placeKey = computed(() =>
  (props.place ?? route.params.place ?? '')
    .toString()
    .trim()
    .toLowerCase()
)

// Your catalog of photos by place (expand as you go)
const catalog = {
  amsterdam: [
    { src: '/portfolio/18.jpg', caption: 'Amsterdam', w: 1365, h: 2048 },
    { src: '/portfolio/19.jpg', caption: 'Amsterdam', w: 2048, h: 1365 },
      { src: '/portfolio/23.jpg', caption: 'Amsterdam', w: 1365, h: 2048 },
    { src: "/portfolio/25.jpg", caption: "Amsterdam",w: 1365, h: 2048  },
    { src: "/portfolio/26.jpg", caption: "Amsterdam", w: 2048, h:1365 },

    { src: "/portfolio/29.jpg", caption: "Amsterdam", w: 2048, h:1365},
    { src: "/portfolio/30.jpg", caption: "Amsterdam",  w: 1365, h: 2048 },
    { src: "/portfolio/31.jpg", caption: "Amsterdam" ,  w: 1365, h: 2048},
    { src: "/portfolio/32.jpg", caption: "Amsterdam",  w: 2048, h:1365 },
    { src: "/portfolio/33.jpg", caption: "Amsterdam", w: 1365, h: 2048 },
      { src: "/portfolio/34.jpg", caption: "Amsterdam" ,  w: 1365, h: 2048},
     { src: "/portfolio/121.jpg", caption: "Amsterdam", w: 2048, h:1365 },

      { src: "/portfolio/123.jpg", caption: "Amsterdam" , w: 1365, h: 2048 },

      { src: "/portfolio/125.jpg", caption: "Amsterdam" ,  w: 1365, h: 2048 },
      { src: "/portfolio/127.jpg", caption: "Amsterdam"  ,  w: 1365, h: 2048 },
      { src: "/portfolio/128.jpg", caption: "Amsterdam"  ,  w: 1365, h: 2048 },
      { src: "/portfolio/129.jpg", caption: "Amsterdam" ,   w: 2048, h:1365 },

     { src: "/portfolio/143.jpg", caption: "Amsterdam",   w: 2048, h:1365 },

      { src: "/portfolio/144.jpg", caption: "Amsterdam",   w: 2048, h:1365 },
      { src: "/portfolio/145.jpg", caption: "Amsterdam" ,   w: 2048, h:1365 },
      { src: "/portfolio/146.jpg", caption: "Amsterdam",  w: 1365, h: 2048 },
      { src: "/portfolio/147.jpg", caption: "Amsterdam" ,  w: 1365, h: 2048 },
      { src: "/portfolio/151.jpg", caption: "Amsterdam",   w: 2048, h:1365 },
      
      { src: "/portfolio/152.jpg", caption: "Amsterdam" ,   w: 2048, h:1365 },
      { src: "/portfolio/153.jpg", caption: "Amsterdam" ,   w: 2048, h:1365 },

      { src: "/portfolio/156.jpg", caption: "Amsterdam" ,   w: 2048, h:1365 },

      { src: "/portfolio/67.jpg", caption: "Amsterdam" , w: 2048, h: 1365},
      { src: "/portfolio/465.jpg", caption: "Amsterdam" , w: 2048, h: 1365},
      { src: "/portfolio/466.jpg", caption: "Amsterdam" ,   w: 1638, h:2048 },
      { src: "/portfolio/467.jpg", caption: "Amsterdam" ,   w: 1365, h:2048 },
      { src: "/portfolio/468.jpg", caption: "Amsterdam" ,   w: 2048, h:1638 },
      { src: "/portfolio/469.jpg", caption: "Amsterdam" ,  w: 2048, h: 1365 },

      { src: "/portfolio/471.jpg", caption: "Amsterdam",   w: 1365, h:2048 },
      { src: "/portfolio/474.jpg", caption: "Amsterdam" ,  w: 2048, h: 1365 },
      { src: "/portfolio/475.jpg", caption: "Amsterdam" ,   w: 2048, h:1536 },
      { src: "/portfolio/476.jpg", caption: "Amsterdam",   w: 2048, h:1365 },
      { src: "/portfolio/521.jpg", caption: "Amsterdam",   w: 2048, h:1365 },
      { src: "/portfolio/522.jpg", caption: "Amsterdam",   w: 2048, h:1365 },

      

  ],
    cologne: [
	// add Hamburg
	{ src: "/portfolio/71.jpg", caption: "Köln",w: 2048, h: 1365 },
	],
  hamburg: [
      // add Hamburg images here
      { src: "/portfolio/54.jpg", caption: "Hamburg",w: 1365, h: 2048 },

    { src: "/portfolio/56.jpg", caption: "Hamburg", w: 1365, h: 2048 },
    { src: "/portfolio/57.jpg", caption: "Hamburg" , w: 1365, h: 2048 },
    { src: "/portfolio/58.jpg", caption: "Hamburg", w: 1365, h: 2048 },
    { src: "/portfolio/59.jpg", caption: "Hamburg" , w: 1365, h: 2048 },
    { src: "/portfolio/60.jpg", caption: "Hamburg", w: 1365, h: 2048 },

    { src: "/portfolio/62.jpg", caption: "Hamburg", w: 2048, h:1365 },
    { src: "/portfolio/63.jpg", caption: "Hamburg" , w: 2048, h:1365 },
    { src: "/portfolio/64.jpg", caption: "Hamburg", w: 2048, h:1365 },

      { src: "/portfolio/66.jpg", caption: "Hamburg", w: 1365, h: 2048 },
      { src: "/portfolio/204.jpg", caption: "Hamburg", w: 1365, h: 2048 },

      {'src': '/portfolio/481.jpg', 'caption': 'Hamburg', 'w': 1638, 'h': 2048},
      {'src': '/portfolio/482.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},

      {'src': '/portfolio/485.jpg', 'caption': 'Hamburg', 'w': 1365, 'h': 2048},
      {'src': '/portfolio/520.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},

      {'src': '/portfolio/488.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},

      {'src': '/portfolio/490.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},


      {'src': '/portfolio/492.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},

      {'src': '/portfolio/494.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},
      {'src': '/portfolio/495.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},

      {'src': '/portfolio/497.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},


      {'src': '/portfolio/500.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},
      {'src': '/portfolio/501.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},
      {'src': '/portfolio/502.jpg', 'caption': 'Hamburg', 'w': 1365, 'h': 2048},
      {'src': '/portfolio/503.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},

      {'src': '/portfolio/506.jpg', 'caption': 'Hamburg', 'w': 1536, 'h': 2048},

      {'src': '/portfolio/508.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},

      {'src': '/portfolio/511.jpg', 'caption': 'Hamburg', 'w': 1365, 'h': 2048},
      {'src': '/portfolio/512.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365}, {'src': '/portfolio/513.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},
      
      {'src': '/portfolio/515.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365}, {'src': '/portfolio/516.jpg', 'caption': 'Hamburg', 'w': 2048, 'h': 1365},

      {'src': '/portfolio/518.jpg', 'caption': 'Hamburg', 'w': 1365, 'h': 2048},
      {'src': '/portfolio/519.jpg', 'caption': 'Hamburg', 'w': 1365, 'h': 2048}      
  ],
sandiego: [

    { src: "/portfolio/209.jpg", caption: "San Diego", w:2048 , h: 1365 },


    { src: "/portfolio/214.jpg", caption: "San Diego", w:1365 , h: 2048 },
    { src: "/portfolio/215.jpg", caption: "San Diego", w: 1365, h: 2048 },        

    { src: "/portfolio/220.jpg", caption: "San Diego", w:2048 , h: 1365 },
 
    { src: "/portfolio/231.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/232.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/233.jpg", caption: "San Diego", w: 2048, h: 1365 },


    { src: "/portfolio/235.jpg", caption: "San Diego", w: 2048, h: 1365 },

    { src: "/portfolio/239.jpg", caption: "San Diego", w: 1365, h: 2048 },

    { src: "/portfolio/241.jpg", caption: "San Diego", w: 1365, h: 2048 },


    { src: "/portfolio/248.jpg", caption: "San Diego", w: 2048, h: 1365 },


    { src: "/portfolio/262.jpg", caption: "San Diego", w: 2048, h: 1365 },    
 { src: "/portfolio/263.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/264.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/265.jpg", caption: "San Diego", w: 2048, h: 1365 },    
 { src: "/portfolio/266.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/267.jpg", caption: "San Diego", w: 2048, h: 1365 },

    { src: "/portfolio/270.jpg", caption: "San Diego", w: 2048, h: 1365 },


    { src: "/portfolio/273.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/274.jpg", caption: "San Diego", w: 2048, h: 1365 },
        { src: "/portfolio/275.jpg", caption: "San Diego", w: 2048, h: 1365 },
        { src: "/portfolio/276.jpg", caption: "San Diego", w: 2048, h: 1365 }
    
    
],
   berlin: [
	    { src: "/portfolio/43.jpg", caption: "Berlin", h: 2048, w: 1365 },
    { src: "/portfolio/45.jpg", caption: "Berlin",w: 2048, h: 1365 },
    { src: "/portfolio/46.jpg", caption: "Berlin" ,w: 2048, h: 1365 },
    { src: "/portfolio/47.jpg", caption: "Berlin" ,w: 2048, h: 1365 },
    { src: "/portfolio/48.jpg", caption: "Berlin" ,w: 2048, h: 1365 },


    { src: "/portfolio/51.jpg", caption: "Berlin" ,w: 2048, h: 1365 },
    { src: "/portfolio/52.jpg", caption: "Berlin" ,w: 2048, h: 1365 }
],
      
    paris: [
	  { src: "/portfolio/74.jpg", caption: "Paris" ,w: 1365, h: 2048 },
      { src: "/portfolio/75.jpg", caption: "Paris" ,w: 1365, h: 2048 },

      { src: "/portfolio/78.jpg", caption: "Paris" ,w: 1365, h: 2048 },



      { src: "/portfolio/83.jpg", caption: "Paris",w: 1365, h: 2048 },
      { src: "/portfolio/84.jpg", caption: "Paris",w: 1365, h: 2048 },
      { src: "/portfolio/85.jpg", caption: "Paris",w: 1365, h: 2048 },
      { src: "/portfolio/86.jpg", caption: "Paris" ,w: 1365, h: 2048},
      { src: "/portfolio/87.jpg", caption: "Paris" },
      { src: "/portfolio/88.jpg", caption: "Paris" },
      { src: "/portfolio/89.jpg", caption: "Paris" },
      { src: "/portfolio/91.jpg", caption: "Paris" },
      { src: "/portfolio/92.jpg", caption: "Paris" },
      { src: "/portfolio/93.jpg", caption: "Paris" },
      { src: "/portfolio/94.jpg", caption: "Paris" },
      { src: "/portfolio/95.jpg", caption: "Paris" },

      { src: "/portfolio/97.jpg", caption: "Paris" },
      { src: "/portfolio/98.jpg", caption: "Paris" },


      { src: "/portfolio/101.jpg", caption: "Paris" ,w: 1365, h: 2048},
      { src: "/portfolio/102.jpg", caption: "Paris" },
      { src: "/portfolio/103.jpg", caption: "Paris" },

      { src: "/portfolio/105.jpg", caption: "Paris" },
      { src: "/portfolio/106.jpg", caption: "Paris" },
      { src: "/portfolio/107.jpg", caption: "Paris" },
      { src: "/portfolio/108.jpg", caption: "Paris" },

      { src: "/portfolio/110.jpg", caption: "Paris" },
      { src: "/portfolio/111.jpg", caption: "Paris" },
      { src: "/portfolio/112.jpg", caption: "Paris" },
      { src: "/portfolio/113.jpg", caption: "Paris" },



    ],
    utrecht: [
	      { src: "/portfolio/118.jpg", caption: "Utrecht" ,w: 1365, h: 2048 },
      { src: "/portfolio/119.jpg", caption: "Utrecht" ,   w: 2048, h:1365 },
      { src: "/portfolio/120.jpg", caption: "Utrecht",w: 1365, h: 2048 },
	{ src: "/portfolio/122.jpg", caption: "Utrecht" ,   w: 2048, h:1365 },
],
	norway: [
	       { src: "/portfolio/131.jpg", caption: "Norway",w: 2048, h: 1365 },      
      { src: "/portfolio/132.jpg", caption: "Norway",w: 2048, h: 1365 },
      { src: "/portfolio/134.jpg", caption: "Norway" ,w: 2048, h: 1365},
      { src: "/portfolio/135.jpg", caption: "Norway" ,w: 2048, h: 1365},

      { src: "/portfolio/138.jpg", caption: "Norway" ,w: 2048, h: 1365},      
      { src: "/portfolio/139.jpg", caption: "Norway" ,w: 2048, h: 1365},
      { src: "/portfolio/140.jpg", caption: "Norway" ,w: 1365, h: 2048},      
	    { src: "/portfolio/141.jpg", caption: "Norway" ,w: 1365, h: 2048},
	],
    costarica: [
	     { src: "/portfolio/159.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
      { src: "/portfolio/160.jpg", caption: "Costa Rica" , w: 2048, h:1365 },
      { src: "/portfolio/161.jpg", caption: "Costa Rica",   w: 2048, h:1365 },
      { src: "/portfolio/162.jpg", caption: "Costa Rica",   w: 2048, h:1365 },
      { src: "/portfolio/163.jpg", caption: "Costa Rica" ,   w: 2048, h:1365 },
      { src: "/portfolio/164.jpg", caption: "Costa Rica" ,w: 1365, h: 2048 }, 
      { src: "/portfolio/165.jpg", caption: "Costa Rica",w: 1365, h: 2048 },
      { src: "/portfolio/166.jpg", caption: "Costa Rica" ,w: 1365, h: 2048 },

      { src: "/portfolio/167.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
      { src: "/portfolio/168.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
      { src: "/portfolio/169.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },

      { src: "/portfolio/172.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      
      { src: "/portfolio/173.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/174.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/176.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/177.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/178.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },


      { src: "/portfolio/182.jpg", caption: "Costa Rica",  w: 2048, h:1365 },

      { src: "/portfolio/184.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },

      { src: "/portfolio/186.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },

      { src: "/portfolio/188.jpg", caption: "Costa Rica",  w: 2048, h:1365 },

      { src: "/portfolio/190.jpg", caption: "Costa Rica",  w: 2048, h:1365 },


      { src: "/portfolio/191.jpg", caption: "Costa Rica" ,w: 1365, h: 2048 }, 
            { src: "/portfolio/192.jpg", caption: "Costa Rica",w: 1365, h: 2048 }, 
      { src: "/portfolio/193.jpg", caption: "Costa Rica",w: 1365, h: 2048 }, 

      { src: "/portfolio/195.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },



      { src: "/portfolio/198.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },

            { src: "/portfolio/199.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/200.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
      { src: "/portfolio/201.jpg", caption: "Costa Rica",  w: 2048, h:1365 },

      { src: "/portfolio/202.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
	{ src: "/portfolio/203.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
    ],
    panama: [


	{ src: "/portfolio/284.jpg", caption: "Panama",  w: 2048, h:1365 },


	{ src: "/portfolio/286.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/292.jpg", caption: "Panama",  w: 1365, h:2048 },
	{ src: "/portfolio/293.jpg", caption: "Panama" ,w: 1365, h: 2048 },	

		{ src: "/portfolio/294.jpg", caption: "Panama" ,w: 1365, h: 2048 },

	{ src: "/portfolio/299.jpg", caption: "Panama" ,w: 1365, h: 2048 },


	{ src: "/portfolio/301.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/302.jpg", caption: "Panama" ,w: 1365, h: 2048 },				
	{ src: "/portfolio/303.jpg", caption: "Panama" ,w: 1365, h: 2048 },

	{ src: "/portfolio/304.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/305.jpg", caption: "Panama" ,w: 1365, h: 2048 },				

    ],
    frankfurt: [
		{ src: "/portfolio/463.jpg", caption: "Frankfurt" ,w: 1365, h: 2048 },
	],
    seattle: [

	{ src: "/portfolio/307.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/308.jpg", caption: "Seattle" ,w: 2048, h: 1365 },


	{ src: "/portfolio/312.jpg", caption: "Seattle" ,w: 1365, h: 2048 },

	{ src: "/portfolio/314.jpg", caption: "Seattle" ,w: 2048, h: 1365 },

	{ src: "/portfolio/318.jpg", caption: "Seattle" ,w: 2048, h: 1365 },



	{ src: "/portfolio/325.jpg", caption: "Seattle" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/326.jpg", caption: "Seattle" ,w: 2048, h: 1365 },

	{ src: "/portfolio/328.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/329.jpg", caption: "Seattle" ,w: 2048, h: 1365 },

	{ src: "/portfolio/331.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/332.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/333.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/334.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/335.jpg", caption: "Seattle" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/336.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/337.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/338.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/339.jpg", caption: "Seattle" ,w: 1365, h: 2048 },					
	{ src: "/portfolio/340.jpg", caption: "Seattle" ,w: 1365, h: 2048 },
	{ src: "/portfolio/341.jpg", caption: "Seattle" ,w: 2048, h: 1365 },

    ],
    seoul: [
	{ src: "/portfolio/342.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/343.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/344.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/345.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/346.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/348.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/349.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/351.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/352.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/354.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/358.jpg", caption: "Seoul" ,w: 1365, h: 2048 },

	{ src: "/portfolio/360.jpg", caption: "Seoul" ,w: 2048, h: 1365 },



	{ src: "/portfolio/372.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/373.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/374.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/375.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/376.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/377.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/378.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/379.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	
	
	{ src: "/portfolio/383.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					

	{ src: "/portfolio/385.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/386.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/388.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					
	
	{ src: "/portfolio/390.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/391.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/392.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					

	{ src: "/portfolio/394.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/395.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/396.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/397.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/398.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/399.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/400.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/401.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/403.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	
	{ src: "/portfolio/404.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/405.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/406.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/407.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/408.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/411.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/412.jpg", caption: "Seoul" ,w: 1365, h: 2048 },					
	{ src: "/portfolio/413.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/414.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/416.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/417.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/419.jpg", caption: "Seoul" ,w: 2048, h: 1365 },


	{ src: "/portfolio/421.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/423.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/425.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/427.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/429.jpg", caption: "Seoul" ,w: 1365, h: 2048 },

	{ src: "/portfolio/432.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/433.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/434.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/435.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/436.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/437.jpg", caption: "Seoul" ,w: 2048, h: 1638 },

	{ src: "/portfolio/443.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/445.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/446.jpg", caption: "Seoul" ,w: 1365, h: 2048 },

	{ src: "/portfolio/448.jpg", caption: "Seoul" ,w: 2048, h: 1365 },


	{ src: "/portfolio/450.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/451.jpg", caption: "Seoul" ,w: 1365, h: 2048 },					

	{ src: "/portfolio/454.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/455.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/456.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/457.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/458.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/459.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/460.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/461.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/462.jpg", caption: "Seoul" ,w: 2048, h: 1365 },	
	
    ],
    "dublin": [

  {
    "src": "/portfolio/541.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/548.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/551.jpg",
    "caption": "Dublin",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/558.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/560.jpg",
    "caption": "Dublin",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/561.jpg",
    "caption": "Dublin",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/563.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/565.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/568.jpg",
    "caption": "Dublin",
    "w": 1638,
    "h": 2048
  },

  {
    "src": "/portfolio/571.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },

  {
    "src": "/portfolio/573.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },

  {
    "src": "/portfolio/575.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },

  {
    "src": "/portfolio/577.jpg",
    "caption": "Dublin",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/578.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },

  {
    "src": "/portfolio/580.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/585.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/586.jpg",
    "caption": "Dublin",
    "w": 1638,
    "h": 2048
  },

  {
    "src": "/portfolio/588.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/589.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/590.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },

  {
    "src": "/portfolio/592.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },


  {
    "src": "/portfolio/602.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/603.jpg",
    "caption": "Dublin",
    "w": 1365,
    "h": 2048
  },


  {
    "src": "/portfolio/609.jpg",
    "caption": "Dublin",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/610.jpg",
    "caption": "Dublin",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/524.jpg",
    "caption": "Dublin",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/528.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  },


  {
    "src": "/portfolio/537.jpg",
    "caption": "Dublin",
    "w": 2048,
    "h": 1638
  }],
    "sanjuan": [
	{"src": "/portfolio/614.jpg",
	 "caption": "San Juan",
    "w": 1638,
    "h": 2048
	 
	},
	{"src": "/portfolio/615.jpg",
	 "caption": "San Juan",
    "w": 2048,
    "h": 1638
	 

  },
	{"src": "/portfolio/616.jpg",
	 "caption": "San Juan",
    "w": 1638,
    "h": 2048
	},
	{"src": "/portfolio/617.jpg",
    "caption": "San Juan",
    "h": 2048,
    "w": 1638
  },
	{"src": "/portfolio/618.jpg",
    "caption": "San Juan",
    "h": 2048,
    "w": 1638
	},
	{"src": "/portfolio/619.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/620.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/621.jpg",
    "caption": "San Juan",
    "h": 2048,
    "w": 1638
  },
	{"src": "/portfolio/622.jpg",
    "caption": "San Juan",
    "h": 2048,
    "w": 1638
	},
	{"src": "/portfolio/623.jpg",
    "caption": "San Juan",
    "h": 2048,
    "w": 1638
  },
	{"src": "/portfolio/627.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/628.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/629.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },

	{"src": "/portfolio/630.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/631.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/632.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/633.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/634.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/635.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/637.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },

	{"src": "/portfolio/638.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/639.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/640.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/641.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },


	{"src": "/portfolio/642.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/644.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/646.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/647.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },

	{"src": "/portfolio/648.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/650.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},

	{"src": "/portfolio/651.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/652.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/653.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/654.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/655.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/656.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/657.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },

	{"src": "/portfolio/658.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/659.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },

	{"src": "/portfolio/662.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/663.jpg",
    "caption": "San Juan",
    "h": 2048,
    "w": 1638
	},
	{"src": "/portfolio/665.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },

	{"src": "/portfolio/672.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/674.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/675.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/677.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },

	{"src": "/portfolio/678.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/679.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/680.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},


	{"src": "/portfolio/681.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/682.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	{"src": "/portfolio/683.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/684.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},

	{"src": "/portfolio/685.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
	{"src": "/portfolio/686.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
	},
	
  {
    "src": "/portfolio/688.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/689.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/690.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/692.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/693.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/694.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/695.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/696.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/697.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/698.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/699.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/700.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/701.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/702.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/703.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/704.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/705.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/706.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/707.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/708.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/710.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/711.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/712.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/713.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/714.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/715.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/716.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/717.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/718.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/719.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/720.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/721.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/722.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/723.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/724.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/725.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/726.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/727.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/728.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/729.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/730.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/731.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/732.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/733.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/734.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/735.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/736.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/737.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/738.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/739.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/740.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/741.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/742.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/743.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/744.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/745.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/746.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/747.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/844.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
	
  {
    "src": "/portfolio/748.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/749.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/750.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },

  {
    "src": "/portfolio/752.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/753.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/754.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/755.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/756.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/757.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/758.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/759.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/760.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/761.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/762.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/763.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/764.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/765.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/766.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/767.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/768.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/769.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/770.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/771.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },

  {
    "src": "/portfolio/773.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/774.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/775.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/776.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/778.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/779.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/780.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/781.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/782.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/783.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/784.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/785.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/786.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/787.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/788.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/789.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/790.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/791.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/794.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/795.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/796.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/797.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/798.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/799.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/800.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/801.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/802.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/803.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/804.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/805.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/806.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/807.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/808.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/809.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/810.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/811.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/812.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/813.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/814.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/815.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/816.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/817.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/818.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/819.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/820.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/821.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/822.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/823.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },

  {
    "src": "/portfolio/825.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/826.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/827.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/828.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/829.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/830.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/831.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/832.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/833.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/834.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/835.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/836.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/837.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/838.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/839.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/840.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/841.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/842.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/843.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/845.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/846.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/847.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/848.jpg",
    "caption": "San Juan",
    "w": 1638,
    "h": 2048
  },
  {
    "src": "/portfolio/849.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1365
  },
  {
    "src": "/portfolio/850.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/851.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/852.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/853.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/854.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/855.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  },
  {
    "src": "/portfolio/857.jpg",
    "caption": "San Juan",
    "w": 2048,
    "h": 1638
  },
  {
    "src": "/portfolio/860.jpg",
    "caption": "San Juan",
    "w": 1365,
    "h": 2048
  }
]
	    
	



}

// Fallback: if place not found, show everything
const allItems = Object.values(catalog).flat()
const items = computed(() => catalog[placeKey.value] ?? allItems)

const resolvedPlaceTitle = computed(() =>
  placeKey.value
    ? placeKey.value[0].toUpperCase() + placeKey.value.slice(1)
    : 'Portfolio'
)

onMounted(() => {
    console.log('mounted') // same timing as Options API's mounted()
    console.log(props)
})
</script>


<style scoped>
.portfolio {
  padding: 16px;
}
.page-title {
  margin: 0 0 16px;
  font-size: clamp(28px, 3vw, 44px);
  line-height: 1.1;
}

.portfolio h1 {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;    /* lighter still */
  font-size: 1.5rem;   /* 24px */
  line-height: 1.4;
  margin: 1rem 0;
  text-align: center;    /* often nice for titles */
  color: orange;
}
</style>
